import {
  Button,
  Grid,
  Table,
  TablePagination,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel
} from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
  ValidatorForm,
} from "react-material-ui-form-validator";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "../../../hooks/useForm";
import {
  conveniosModulosGetActivos,
  conveniosEliminarModulo,
  conveniosEditarModulo,
  generateExcelValorizaciones,
  setActivosPorFecha,
  conveniosReactivarModulo,
  generatePDFValorizaciones,
  conveniosModulosGetCarga,
} from "../../../actions/contrataciones/contratacionesConvenios";
import { startAlerta } from "../../../actions/ui/alertas";
import BuscadorConvenios from "./BuscadorConvenios";
import DeleteConveniosButton from "./DeleteConveniosButton";
import EditConveniosButton from "./EditConveniosButton";
import { useReactToPrint } from "react-to-print";
import BuscadorModulos from "./BuscadorModulos";
import { CAT_HONGAS_VALORIZACIONES, TIPO_PRACTICAS_POR_FECHA } from "../../../utils/constants";
import ReactivarConveniosButton from "./ReactivarConveniosButton";
import { TablePaginationActions } from "../../compartidos/TablePaginationActions";
import { ConveniosModulosCarga } from "./ConveniosModulosCarga";

export const ConveniosModulos = (props) => {
  moment.locale("es");
  const dispatch = useDispatch();
  const childRefModulo = useRef(null);

  const { dataContrato } = useSelector((state) => state.contrataciones);
  const { modulosActivos } = useSelector((state) => state.contratacionesConvenios);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [showTable, setShowTable] = useState(false);

  const initialValues = {
    modulo: null,
    fechaInicioVigencia: null,
    honGas: ""
  };

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
    ,
  ] = useForm(initialValues);

  const { modulo, fechaInicioVigencia, honGas } = formValues;

  const componentRef = React.useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onChangeRadioHandler = (e) => {
    setearValor("honGas", e.target.value === "" ? "" : parseInt(e.target.value));
  };

  const deletePracticasActivasHandler = (idItem) => {
    dispatch(conveniosEliminarModulo(dataContrato.idEfectorFacturacion, idItem));
  };

  const reactivarPracticaHandler = (idItem) => {
    dispatch(conveniosReactivarModulo(dataContrato.idEfectorFacturacion, idItem));
  };

  const handleEditPractica = (idItem, data) => {
    dispatch(conveniosEditarModulo(dataContrato.idEfectorFacturacion, idItem, data));
  };

  const resetForm = () => {
    setearVariosValores(initialValues);
    childRefModulo.current.resetValues();
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (!modulo) {
      dispatch(startAlerta("Ingrese el modulo.", "error"))
    } else {
      const data = {
        idEfectorFacturacion: dataContrato.idEfectorFacturacion,
        idModulo: modulo?.idModulo,
        fechaInicioVigencia: fechaInicioVigencia.toLocaleDateString("en-US"),
        idHonGas: honGas
      };

      dispatch(conveniosModulosGetCarga(data, () => { setShowTable(true) }));
    }
  };

  const handleGetPracticas = (tipoDataPorFecha) => {
    dispatch(conveniosModulosGetActivos(dataContrato?.idEfectorFacturacion, tipoDataPorFecha));
  }

  useEffect(() => {
    dispatch(conveniosModulosGetActivos(dataContrato?.idEfectorFacturacion));
  }, []);

  // VALIDATORS
  useEffect(() => {
    const fechaInicioVigenciaContrato = dataContrato?.fechaInicioVigencia;
    const fechaFinVigenciaContrato = dataContrato?.fechaFinVigencia;

    // FECHA INICIO VIGENCIA
    ValidatorForm.addValidationRule(
      "isAfterFechaInicioVigenciaContrato",
      (value) => {
        if (
          moment(value).isValid() &&
          moment(value).isBefore(moment(fechaInicioVigenciaContrato))
        ) {
          return false;
        }
        return true;
      }
    );

    // FECHA INICIO VIGENCIA
    ValidatorForm.addValidationRule(
      "isBeforeFechaFinVigenciaContrato",
      (value) => {
        if (
          moment(value).isValid() &&
          moment(value).isAfter(moment(fechaFinVigenciaContrato))
        ) {
          return false;
        }
        return true;
      }
    );
  });

  useEffect(() => {
    return () => {
      dispatch(setActivosPorFecha(TIPO_PRACTICAS_POR_FECHA.VIGENTES))
    }
  }, [])

  return (
    <React.Fragment>

      <Dialog
        fullWidth
        maxWidth="xl"
        open={showTable}
        onClose={() => setShowTable(false)}
      >
        <DialogTitle>Confirmar Practicas</DialogTitle>
        <DialogContent>
          <ConveniosModulosCarga
            setShowTable={setShowTable}
            resetForm={resetForm}
          />
        </DialogContent>
      </Dialog>
      <Grid container spacing={2}>
        {!props.fieldsDisabled && (
          <Grid item xs={3}>
            <Card style={{ padding: "1rem" }}>
              <ValidatorForm onSubmit={submitHandler}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <MuiPickersUtilsProvider
                      locale={esLocale}
                      utils={DateFnsUtils}
                    >
                      <ValidatedDatePicker
                        fullWidth={true}
                        label="Fecha Inicio Vigencia"
                        format="dd/MM/yyyy"
                        maxDate={moment(new Date()).add(3, "Y")}
                        okLabel="Aceptar"
                        clearLabel="Limpiar"
                        cancelLabel="Cancelar"
                        name="fechaInicioVigencia"
                        value={
                          fechaInicioVigencia !== undefined &&
                            moment(fechaInicioVigencia).isValid()
                            ? moment(fechaInicioVigencia)
                            : null
                        }
                        disabled={props.fieldsDisabled}
                        onChange={(e) => setearValor("fechaInicioVigencia", e)}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                        }}
                        validators={[
                          "required",
                          "isAfterFechaInicioVigenciaContrato",
                          "isBeforeFechaFinVigenciaContrato",
                        ]}
                        errorMessages={[
                          "La fecha de inicio de vigencia es requerida",
                          "La fecha de inicio de vigencia debe ser mayor a la fecha de inicio de vigencia del contrato",
                          "La fecha de inicio de vigencia debe ser menor a la fecha de fin de vigencia del contrato",
                        ]}
                      />
                    </MuiPickersUtilsProvider>
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
                    <BuscadorModulos ref={childRefModulo} cod={modulo} label="Módulo" fieldsDisabled={props.fieldsDisabled} setCod={(val) => setearValor("modulo", val)} idEfectorFacturacion={dataContrato.idEfectorFacturacion} />
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
                    <FormControl component="fieldset">
                      <FormLabel component="legend"></FormLabel>
                      <RadioGroup
                        row
                        name="honGas"
                        value={honGas}
                        onChange={onChangeRadioHandler}
                      >
                        <FormControlLabel
                          value={""}
                          control={<Radio size="small" />}
                          label="HyG"
                          disabled={props.fieldsDisabled}
                        />
                        <FormControlLabel
                          value={CAT_HONGAS_VALORIZACIONES.HG}
                          control={<Radio size="small" />}
                          label="H-G"
                          disabled={props.fieldsDisabled}
                        />
                        <FormControlLabel
                          value={CAT_HONGAS_VALORIZACIONES.H}
                          control={<Radio size="small" />}
                          label="H"
                          disabled={props.fieldsDisabled}
                        />
                        <FormControlLabel
                          value={CAT_HONGAS_VALORIZACIONES.G}
                          control={<Radio size="small" />}
                          label="G"
                          disabled={props.fieldsDisabled}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      CONSULTAR
                    </Button>
                  </Grid>
                </Grid>
              </ValidatorForm>
            </Card>
          </Grid>
        )}
        <Grid item xs={!props.fieldsDisabled ? 9 : 12}>
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <BuscadorConvenios
                disabled
                handleSearch={handleGetPracticas}
                handlePrint={handlePrint}
                handleExportExcel={(dataPorFecha) => dispatch(generateExcelValorizaciones(dataContrato.idEfectorFacturacion, dataContrato.idTipoNomenclador, dataPorFecha))}
                handleGeneratePdf={(dataPorFecha) => dispatch(generatePDFValorizaciones(dataContrato.idEfectorFacturacion, dataContrato.idTipoNomenclador, dataPorFecha))}
              />
            </Grid>
            <Grid item xs={12}>
              <Card>
                <Table ref={componentRef}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ width: "5%" }}>
                        Codigo Modulo
                      </TableCell>
                      <TableCell style={{ width: "25%" }}>
                        Nombre Modulo
                      </TableCell>
                      <TableCell style={{ width: "5%" }}>Valor</TableCell>
                      <TableCell style={{ width: "5%" }}>H/G</TableCell>
                      <TableCell style={{ width: "10%" }}>
                        Fecha Inicio Vigencia
                      </TableCell>
                      <TableCell style={{ width: "10%" }}>
                        Fecha Fin Vigencia
                      </TableCell>
                      <TableCell style={{ width: "2%" }}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {modulosActivos
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((modulo, index) => {
                        return (
                          <TableRow
                            key={index}
                          >
                            <TableCell>{modulo.codigo}</TableCell>
                            <TableCell>{modulo.descripcion}</TableCell>
                            <TableCell>{modulo.valor}</TableCell>
                            <TableCell>
                              {modulo.idHonGas === null && "HyG"}
                              {modulo.idHonGas === CAT_HONGAS_VALORIZACIONES.H && "H"}
                              {modulo.idHonGas === CAT_HONGAS_VALORIZACIONES.G && "G"}
                            </TableCell>
                            <TableCell>
                              {new Date(
                                modulo.fechaInicioVigencia
                              ).toLocaleDateString()}
                            </TableCell>
                            <TableCell>
                              {new Date(
                                modulo.fechaFinVigencia
                              ).toLocaleDateString()}
                            </TableCell>
                            {!props.fieldsDisabled && (
                              <TableCell >
                                <div style={{ display: "flex" }}>
                                  <EditConveniosButton idItem={modulo.idValorizacionModulo} item={modulo} editItem={handleEditPractica} />
                                  {
                                    (modulo.fechaBaja !== null && moment(modulo.fechaBaja).isSame(moment(), 'day'))
                                      ?
                                      <ReactivarConveniosButton idItem={modulo.idValorizacionModulo} reactivarPractica={reactivarPracticaHandler} />
                                      :
                                      (
                                        !moment(modulo.fechaFinVigencia).isSameOrBefore(moment(), 'day') &&
                                        <DeleteConveniosButton idItem={modulo.idValorizacionModulo} fechaInicioVigencia={modulo.fechaInicioVigencia} deletePracticas={deletePracticasActivasHandler} vigente={moment().isSameOrAfter(modulo.fechaInicioVigencia) && moment().isSameOrBefore(modulo.fechaFinVigencia)} modulos={true} />
                                      )
                                  }
                                </div>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
                <TablePagination
                  component="div"
                  className="paginador"
                  count={modulosActivos.length}
                  rowsPerPageOptions={[20, 50, 100]}
                  labelRowsPerPage="Filas por página"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${count}`
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
